/* global document */
/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom";
import "typeface-roboto/index.css";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js